var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo, useMemo } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
var cn = classnames.bind(styles);
var BLOCK_NAME = 'Skeleton';
export var Skeleton = memo(function (_a) {
    var screenType = _a.screenType;
    var numberOfLines = useMemo(function () { return (screenType === 'mobile' ? 6 : 10); }, [
        screenType,
    ]);
    var linesArray = useMemo(function () { return __spreadArray([], __read(new Array(numberOfLines)), false).map(function (item, index) { return index; }); }, [numberOfLines]);
    return (React.createElement("div", { className: cn(BLOCK_NAME) }, linesArray.map(function () { return (React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line")) })); })));
});
